import { Injectable, NgZone, Inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RoutesRecognized } from "@angular/router";
import { HttpHeaders, HttpClient } from "@angular/common/http";

import { Observable, of } from "rxjs";

import { ADPResourceService as ResourceService, SitefinityMenuItem } from 'digital-core';
import { HeaderFactoryService } from './header-factory.service';
import { ConfigService } from './config.service';
import { LoginService } from "./login.service";
import { AuthenticationService } from "./authentication.service";

@Injectable()
export class AuthorizationService {
  url: string;
  resolving: boolean;
  menuItems: SitefinityMenuItem[];
  httpOptionsObserveResponse = {
    headers: new HttpHeaders({
      Accept: "application/json",
    }),
    observe: "response",
  };

  constructor(
    public authenticationService: AuthenticationService,
    private resourceService: ResourceService,
    private httpsClient: HttpClient,
    private configService: ConfigService,
    private headerService: HeaderFactoryService,
    public loginService: LoginService,
    public ngZone: NgZone
  ) {
    this.url = "/";
    this.resolving = false;
    //   this.getLeftMenu();
  }

  hasAccessToResource(resource: string): Observable<boolean> {
    let isAuthenticated = this.authenticationService.isAuthenticated();
    if (!isAuthenticated) {
      return of(false);
    }
    if (!resource) {
      resource = "";
    }
    return this.checkAccess(resource);
  }

  hasResourceAccess(resource: string): boolean {
    let isAuthenticated = this.authenticationService.isAuthenticated();
    if (!isAuthenticated) {
      return false;
    }
    if (!resource) {
      resource = "";
    }
    return true;
  }

  private checkAccess(resource: string): Observable<boolean> {
    // we need to call the web api to find out if the customer has access to the resource.
    return this.httpsClient.get<boolean>(
      `${this.configService.apiUrl}api/v${this.configService.apiVersion}/auth/checkAccess?resource=${resource}`,
      this.headerService.getAuthorizationHeaderOptions(["systemRole"])
    );
  }

  nextPage(router: Router): Observable<boolean> | Promise<boolean> {
    if (this.menuItems !== null && this.menuItems !== undefined) {
      if (this.menuItems[0] !== undefined) {
        // if (this.currentPage !== this.menuItems[0].LinkUrl) {
        this.url = this.menuItems[0].LinkUrl;
        router.navigateByUrl(this.menuItems[0].LinkUrl);
        //  }
        return of(false);
      }
    }
    return of(true);
  }

  isAvailable(page): boolean {
    if (
      this.menuItems !== null &&
      this.menuItems !== undefined &&
      this.menuItems.length > 0 &&
      page !== undefined
    ) {
      let array = this.menuItems.filter((x) => page.includes(x.LinkUrl));
      if (array.length === 0) {
        return false;
      } else {
        return true;
      }
    }
    return false;
  }

  getLeftMenu() {
    let scope = this;
    let menues = this.resourceService.getPortalMenus("Menu");
    let menues2 = this.resourceService.getPortalMenus("Portal_Footer");
    let promise = new Promise<void>((resolve, reject) => {
      if (menues !== null && menues !== undefined) {
        menues.subscribe(
          (response) => {
            if (
              response !== undefined &&
              response !== null &&
              response.MenuItems !== null &&
              response.MenuItems !== undefined
            ) {
              scope.menuItems = response.MenuItems.filter(
                (x) => x.Hidden === false
              );
              resolve();
            } else {
              reject();
            }
          },
          (error) => {
            reject();
          }
        );
      }
      if (menues2 !== null && menues2 !== undefined) {
        menues2.subscribe(
          (response) => {
            if (
              response !== undefined &&
              response !== null &&
              response.MenuItems !== null &&
              response.MenuItems !== undefined
            ) {
              scope.menuItems = response.MenuItems.filter(
                (x) => x.Hidden === false
              );
              resolve();
            } else {
              reject();
            }
          },
          (error) => {
            reject();
          }
        );
      }
    });
    return promise;
  }

  public canActivate(
    page: string,
    router: Router,
    route: ActivatedRouteSnapshot
  ): boolean | Observable<boolean> {
    let scope = this;

    return new Observable<boolean>((observer) => {
      if (this.configService.getEnableClientAULLogin && this.configService.getEnableClientAULLogin == 'true') {
        this.loginService.isValidTokenAsync().subscribe(
          (result) => {
            if (!result || !scope.authenticationService.existUserProfile()) {
              scope.ngZone.run(() => {
                if (!!route.queryParams['isAUL']) {
                  router.navigateByUrl("Public/Login?isAUL=" + route.queryParams['isAUL']);
                } else {
                  router.navigateByUrl("Public/Login");
                }
              });
              return observer.next(false);
            } else {
              if (window['config'].core.clientCMS.length > 0) {
                scope.getLeftMenu().then(
                  () => {
                    if (!scope.isAvailable(page)) {
                      scope
                        .hasAccessToResource(route.data.view)
                        .subscribe((accessResult) => {
                          if (!accessResult) {
                            scope.nextPage(router);
                            return observer.next(false);
                          } else {
                            let filteredpage = this.resourceService.siteMenus['Menu'].MenuItems.find(x => x.LinkUrl.toLowerCase() == page.toLowerCase());
                            if (!filteredpage && page != '/') {
                              scope.ngZone.run(() =>
                                router.navigateByUrl(this.getDefaultRoute(page))
                              );
                              return observer.next(false);
                            }
                            return observer.next(true);
                          }
                        });
                    } else {
                      if (
                        !this.authenticationService.isAuthenticated() ||
                        !scope.isAvailable(page)
                      ) {
                        // scope.authenticationService.logOut();
                        scope.ngZone.run(() =>
                          router.navigateByUrl("Public/Login")
                        );
                        return observer.next(false);
                      }
                      let filteredpage = this.resourceService.siteMenus['Menu'].MenuItems.find(x => x.LinkUrl.toLowerCase() == page.toLowerCase());
                      if (!filteredpage && page != '/') {
                        scope.ngZone.run(() =>
                          router.navigateByUrl(this.getDefaultRoute(page))
                        );
                        return observer.next(false);
                      }
                      return observer.next(true);
                    }
                  },
                  (err) => {
                    // scope.authenticationService.logOut();
                    scope.ngZone.run(() => router.navigateByUrl("Public/Login"));
                    return observer.next(false);
                  }
                );
              } else {
                scope.ngZone.run(() => router.navigateByUrl("Public/Login"));
                observer.next(false);
              }
            }
          },
          (error) => {
            return observer.next(false);
          }
        );
      }
      else {
        return observer.next(true);
      }
    });
  }

  public getDefaultRoute(page: string): string {
    if (this.resourceService.siteMenus) {
      let filteredPage = this.resourceService.siteMenus['Menu'].MenuItems.find(x => x.LinkUrl.toLowerCase() == page.toLowerCase());
      if (filteredPage) {
        return filteredPage.Caption;
      }
    }
    const defaultWildcardRoute = this.configService.getDefaultRoute;
    if (defaultWildcardRoute) {
      return defaultWildcardRoute;
    }
    else {
      return 'index';
    }
  }
}
